import { createLocalChecker } from "./providers/local";
import { defaultFor } from "./registry";

let check = createLocalChecker();

export const registerChecker = (fn) => {
  check = fn || createLocalChecker();
};

export const FeatureFlag = {
  isFeatureActive: (flagName) => {
    try {
      return !!check(flagName);
    } catch {
      return defaultFor(flagName);
    }
  },
  __clearForTests: () => registerChecker(null),
};
